export enum EPropertyDetailsTabs {
  Info,
  Contract,
  Documents,
  History,
}
